import { render, staticRenderFns } from "./emptyBed.vue?vue&type=template&id=51f600e0&"
import script from "./emptyBed.vue?vue&type=script&lang=js&"
export * from "./emptyBed.vue?vue&type=script&lang=js&"
import style0 from "./emptyBed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports